<template>
  <div>
    <section id="container" style="height: calc(100vh - 50px)" />
    <!-- <div class="export-btn-wrapper">
      <el-button
        type="primary"
        :loading="exportLoading"
        size="small"
        @click="exportToPdf()"
        >Export to PDF</el-button
      >
    </div> -->
  </div>
</template>

<script>
import ApiService from '@/services/ApiService.js'
import * as pbi from 'powerbi-client'
import swal from 'sweetalert'

export default {
  data() {
    return {
      config: null,
      minutesBeforeExpiration: 2,
      intervalTime: 3000,
      checkTokenAndUpdateTimer: null,
      dashboard: null,
      exportLoading: false
    }
  },
  mounted() {
    this.loadReport()
  },
  methods: {
    getConfig() {
      return new Promise((resolve, reject) => {
        const user = this.$store.state.user.loggedInUser
        if (!user) {
          reject('User not logged in')
        } else {
          let showPID = null
          const selectedOrganisation = user.organisations.filter(
            item => item.Active
          )
          if (selectedOrganisation && selectedOrganisation.length) {
            showPID = selectedOrganisation[0].OrganisationName.DeIdentify
          }

          ApiService.GetReportConfiguration(
            this.$store.getters[`user/selecteOrganisationId`],
            showPID
          )
            .then(res => {
              this.config = res.data.data
              resolve() // Resolve the Promise when the report is loaded
            })
            .catch(error => {
              reject(error) // Reject the Promise if there's an error
            })
        }
      })
    },
    loadReport() {
      this.getConfig().then(() => {
        const permissions = pbi.models.Permissions.All
        const config = {
          type: 'report',
          accessToken: this.config.embedToken.token,
          embedUrl: this.config.embedReports[0].embedUrl,
          id: this.config.embedReports[0].id,
          pageView: 'fitToWidth',
          permissions: permissions,
          tokenType: pbi.models.TokenType.Embed
        }

        let powerbi = new pbi.service.Service(
          pbi.factories.hpmFactory,
          pbi.factories.wpmpFactory,
          pbi.factories.routerFactory
        )
        const dashboardContainer = document.getElementById('container')
        this.dashboard = powerbi.embed(dashboardContainer, config)

        this.dashboard.off('loaded')
        this.dashboard.off('rendered')
        this.dashboard.on('error', function() {
          this.dashboard.off('error')
        })

        // start timer
        this.checkTokenAndUpdateTimer = setInterval(
          () => this.checkTokenAndUpdate(),
          this.intervalTime
        )
      })
    },
    checkTokenAndUpdate() {
      // Get the current time
      const currentTime = Date.now()
      const expiration = Date.parse(this.config.embedToken.expiration)

      // Time until token expiration in milliseconds
      const timeUntilExpiration = expiration - currentTime
      const timeToUpdate = this.minutesBeforeExpiration * 60 * 1000

      // Update the token if it is about to expired
      if (timeUntilExpiration <= timeToUpdate) {
        this.updateToken()
      }
    },
    updateToken() {
      this.getConfig().then(() => {
        // Set the new access token
        this.dashboard.setAccessToken(this.config.embedToken.token)
      })
    },
    async exportToPdf() {
      let bookmarkResult = await this.dashboard.bookmarksManager.capture({
        personalizeVisuals: false,
        allPages: true
      })
      if (!bookmarkResult) {
        swal({
          icon: 'error',
          timer: 2000,
          title: 'Export Failed'
        })
        return false
      }
      this.exportLoading = true
      ApiService.GetReportInPdf(
        this.$store.getters[`user/selecteOrganisationId`],
        {
          BookmarkState: bookmarkResult.state,
          PageName: 'test'
        }
      )
        .then(response => {
          this.exportLoading = false
          let FileSaver = require('file-saver')
          FileSaver.saveAs(response.data, 'Smartz Report.pdf')
        })
        .catch(() => {
          this.exportLoading = false
          swal({
            icon: 'error',
            timer: 2000,
            title: 'Export Failed'
          })
        })
    }
  },
  beforeDestroy() {
    clearInterval(this.checkTokenAndUpdateTimer)
  }
}
</script>

<style lang="scss">
.report-container {
  height: 75vh;
  margin: 8px auto;
  width: 90%;
}
.export-btn-wrapper {
  position: absolute;
  right: 20px;
  top: 12px;
  .el-button--primary {
    background-color: #5b588e;
    border-color: #5b588e;
  }
}
</style>
